import { useGetDriversQuery, useGetDriverByIdQuery } from '../../Drivers/services';
import { Option } from '@/components/inputs/AutocompleteInput';
import { useEffect, useMemo, useState } from 'react';

interface UseDriverSearchInputProps {
  driverId?: string;
}

const useDriverSearchInput = ({ driverId }: UseDriverSearchInputProps) => {
  const [selectedDriver, setSelectedDriver] = useState<Option | null>(null);
  const [driverSearch, setDriverSearch] = useState('');

  const { data: driversData, isLoading: isDriversLoading } = useGetDriversQuery(
    { filters: { search: driverSearch }, paginated: { page: 1, pageSize: 20 } },
    { skip: driverSearch.length < 3 }
  );

  const driverOptions: Option[] = useMemo(
    () =>
      (driversData?.items ?? []).map((driver) => ({
        label: `${driver.firstName} ${driver.lastName}`,
        data: driver.id,
      })),
    [driversData]
  );

  const driverIdForLookup = driverId?.trim() ?? '';

  const { data: driverByIdData } = useGetDriverByIdQuery(
    { id: driverIdForLookup },
    { skip: !driverIdForLookup || !!selectedDriver }
  );

  useEffect(() => {
    if (!selectedDriver && driverIdForLookup && driverByIdData) {
      setSelectedDriver({
        label: `${driverByIdData.firstName} ${driverByIdData.lastName}`,
        data: driverByIdData.id,
      });
    }
  }, [driverByIdData, driverIdForLookup, selectedDriver]);

  useEffect(() => {
    if (!driverId) setSelectedDriver(null);
  }, [driverId]);

  const handleDriverSelect = (option: Option | null) => {
    setSelectedDriver(option);
  };

  const clearDriver = () => {
    setDriverSearch('');
    setSelectedDriver(null);
  };

  return {
    selectedDriver,
    driverSearch,
    setDriverSearch,
    driverOptions,
    isDriversLoading,
    handleDriverSelect,
    clearDriver,
  };
};

export default useDriverSearchInput;
